import utils from "@/utilities/Utils";
import { SearchParameters } from "./SearchParameters";

export class ProductSearchParameters {
    searchParameters: SearchParameters = new SearchParameters();
    typeID: string = utils.emptyGuidValue;
    rangeID: string = utils.emptyGuidValue;
    showHidden: boolean = false;
}